// src/posts/index.js
// Add new articles here as you write them

import { meta as periMeta, content as periContent } from './is-it-perimenopause';
import { meta as gpMeta, content as gpContent } from './gp-dismissing-perimenopause';
import { meta as prepMeta, content as prepContent } from './prepare-for-perimenopause-appointment';
import { meta as unexpectedMeta, content as unexpectedContent } from './unexpected-perimenopause-symptoms';
import { meta as hrtMeta, content as hrtContent } from './benefits-of-tracking-your-hrt-journey';

export const posts = [
  { ...gpMeta, content: gpContent },
  { ...periMeta, content: periContent },
  { ...prepMeta, content: prepContent },
  { ...unexpectedMeta, content: unexpectedContent },
  { ...hrtMeta, content: hrtContent },
];

export function getPostBySlug(slug) {
  return posts.find(p => p.slug === slug) || null;
}
